<template>
  <router-link
    :to="link"
    class="main-item-wrapper d-flex flex-column cursor-pointer"
  >
    <div class="item_img">
      <img :src="image" @error="imageLoadError($event)" />
      <div
        class="tags-wrapper d-flex justify-content-center align-items-center"
      >
        <span class="tags-text">Live</span>
      </div>
    </div>

    <div v-if="title">
      <p class="mb-0 title_text text-left mt-2">{{ title }}</p>
    </div>
  </router-link>
</template>

<script>
/* eslint-disable */
import noimage from "../../../assets/noimage.png";
export default {
  name: "tv-card-comp",
  props: ["image", "latestTag", "title", "description", "link", "category"],
  data: function() {
    return {
      mobile: false,
      window: {
        width: 0,
      },
    };
  },
  methods: {
    imageLoadError(event) {
      event.target.src = noimage;
    },
    goTo(link) {
      this.$router.push(link);
    },

    truncateString(str, num) {
      if (str.length > num) {
        return str.slice(0, num) + "...";
      } else {
        return str;
      }
    },
    handleResizeforCard() {
      this.window.width = window.innerWidth;

      if (this.window.width >= 992) {
        this.mobile = false;
      } else {
        this.mobile = true;
      }
    },
  },
  created() {
    window.addEventListener("resize", this.handleResizeforCard);
    this.handleResizeforCard();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResizeforCard);
  },
};
</script>

<style scoped>
.main-item-wrapper {
  z-index: 1;
  text-decoration: none;
}
.main-item-wrapper:hover .title {
  color: #d9e02f;
}
.item_img {
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  padding-top: calc(145 / 220 * 100%);
  z-index: 1;
}
.item_img img {
  background: 100%;
  width: 100%;
  height: 100%;
  overflow: hidden;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  position: absolute;
  z-index: 2;
}

.tags-wrapper {
  width: 45px;
  padding: 2px 4px;
  height: 20px;
  position: absolute;
  right: 0;
  top: 8px;
  background-color: #f00;
  z-index: 4;
}
.tags-text {
  font-size: 12px;
  font-family: "HelveticaNeue-Bold";
  font-weight: bold;
  line-height: 1.25;
  text-align: left;
  color: #fff;
  z-index: 4;
}

.title_text {
  color: #fff;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
@media only screen and (max-width: 992px) {
  .item_img {
    filter: saturate(100%);
  }
}
@media only screen and (max-width: 480px) {
}
</style>
<style>
@media only screen and (max-width: 480px) {
}
</style>
